import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '../../Components/Button';
import TokenContainer from './TokenContainer';
import { RootState } from '../../Redux/reducers';
import {
  createToken, downloadFile, restoreDB, getTokens, deleteItem,
} from './adminLogic';
import DeleteModal from '../../Components/DeleteModal';

const valertTier = process.env.REACT_APP_VALERT_TIER;

const Admin = (): JSX.Element => {
  const dispatch = useDispatch();
  const {
    tokens, tokensVisited,
  } = useSelector((state: RootState) => state.admin);
  const { socket } = useSelector((state: RootState) => state.socket); // eslint-disable-line
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [showTokenDelete, setShowTokenDelete] = useState(false);
  const [render, setRender] = useState(false);

  useEffect(() => {
    if (!tokensVisited || !tokens.length) getTokens(dispatch);
  }, [render]);

  const toggleTokenModal = () => {
    setShowTokenDelete(!showTokenDelete);
  };

  const deleteToken = () => {
    deleteItem({ id, name }, 'tokens', dispatch, socket, setRender, render);
  };

  const showTokenDeleteModal = (tokenId: string, tokenName: string) => {
    setId(tokenId);
    setName(tokenName);
    setShowTokenDelete(true);
  };

  return (
    <main className="outerFlexContainer">
      {showTokenDelete && <DeleteModal open={showTokenDelete} toggleModal={toggleTokenModal} deleteTitle="token" deleteFunction={deleteToken} /> }
      <div>
        <section aria-label="Database and Logs" className="sectionHeading">
          <h1
            tabIndex={0} // eslint-disable-line
          >
            Database and Logs
          </h1>
        </section>
        <section className="admin-buttons">
          <Button ariaLabel="Download Database Button" onClick={() => downloadFile('db', dispatch)} text="Download Database" />
          <Button ariaLabel="Download All Logs Button" onClick={() => downloadFile('log', dispatch)} text="Download All Logs" />
          <Button
            ariaLabel="Restore Database Button"
            onClick={() => true}
            text={(
              <label htmlFor="file" className="input-file-label">
                Restore Database
                <input type="file" id="file" name="fle" onChange={(e) => restoreDB(e, dispatch)} className="input-file" />
              </label>
                )}
          />
        </section>
      </div>
      {valertTier === 'pro' && (
        <div className="token-container">
          <TokenContainer
            contents={tokens}
            createToken={createToken}
            reRender={render}
            reRenderFunc={setRender}
            showDelete={showTokenDeleteModal}
          />
        </div>
      )}
    </main>
  );
};

export default Admin;
